import React, {useCallback, useMemo, useState} from "react"
import {useLocalization} from "../../../../hooks/localization"
import {BridgeDeviceModel} from "../../../../types/bridge-device"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {ColumnModel, SettingsList} from "../../../../components/Settings/SettingsList"
import {useFilterSelector} from "../../../../hooks/filter-selector"
import {BRIDGE_DEVICE_TYPE_ID_FRAME} from "../../../../types/control"
import {useSetSelector} from "../../../../hooks/set-selector"

const keyExtractor = (item: BridgeDeviceModel) => item.id

export function FrameEditorListScreen() {
    const {t} = useLocalization()
    const [selectedMenuItem, setSelectedMenuItem] = useState<BridgeDeviceModel>(null)
    const frameDeviceList = useFilterSelector(
        state => state.control.bridgeDeviceList,
        d => d.type_id === BRIDGE_DEVICE_TYPE_ID_FRAME
    )
    const deviceTypeSet = useSetSelector(state => state.control.bridgeDeviceTypeList)

    const buttons = useMemo(
        () => [
            {
                text: t("edit"),
                url: `/settings/frame-editor/${selectedMenuItem ? selectedMenuItem.id : ""}`,
                className: "blue",
                hidden: !selectedMenuItem
            }
        ],
        [t, selectedMenuItem]
    )

    const displayNameExtractor = useCallback(
        (item: BridgeDeviceModel, column: ColumnModel) => {
            if (column.key === "name") {
                return item.name || "-"
            }

            if (column.key === "type") {
                return deviceTypeSet[item.type_id]?.name
            }

            return item[column.key] || "-"
        },
        [deviceTypeSet]
    )

    const columns = useMemo<ColumnModel[]>(
        () => [
            {
                length: 3,
                name: t("device_name"),
                key: "name"
            },
            {
                length: 3,
                name: t("device_type"),
                key: "type"
            }
        ],
        [t]
    )
    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} backUrl={"/settings"} searchable={true}>
                <SettingsList
                    columns={columns}
                    items={frameDeviceList}
                    selectedItem={selectedMenuItem}
                    onItemSelected={setSelectedMenuItem}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                />
            </SettingsPageContainer>
        </PasswordContainer>
    )
}
